var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.prefixCls},[_c('Logo'),_c('Tabs')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }